export const metaConfig = [
    {
        path: '/framework',
        title: 'AVAP Framework: an API Lifecycle Management Platform',
        description: 'Discover AVAP Framework a complete API lifecycle management. Design, develop, publish, and scale APIs seamlessly. Virtual and Gen-AI.',
        url: 'https://avapframework.com',
        favicon: '/assets/img/Favicon_AVAP_Framework',
        canonicalUrl: 'https://avapframework.com/',
    },
    {
        path: '/products/avap',
        title: 'AVAP: High-Level Programming Language for Virtual APIs',
        description: 'Discover AVAP, advanced virtual and intelligent API programming language. Simplify API development with an efficient, and innovative approach.',
        url: 'https://avapframework.com/products/avap/',
        favicon: '/favicon.svg',
    },
    {
        path: '/products/vsc-extensions',
        title: 'AVAP API Extensions for Microsoft Visual Studio Code',
        description: 'Discover AVAP extensions to build, version, and publish Virtual APIs seamlessly in Microsoft Visual Studio Code. Simplify your Virtual API workflow with powerful tools.',
        url: 'https://avapframework.com/products/vsc-extensions/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/devstudio',
        title: 'AVAP Dev Studio: Collaborative IDE for API Development',
        description: 'AVAP Dev Studio, an IDE for Virtual API creation, management, and optimization with real-time code editing, intelligent error detection, and dynamic testing.',
        url: 'https://avapframework.com/products/devstudio/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/source-control',
        title: 'AVAP API Source Control: Version Management for APIs',
        description: 'AVAP API Source Control, manage code repositories, track changes, and control API deployments across environments with AVAP\'s built-in source control.',
        url: 'https://avapframework.com/products/source-control/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/api-publisher',
        title: 'AVAP API Publisher: Efficient API Publication & Management',
        description: 'Discover AVAP API Publisher. Publish tested, versioned APIs to the LIVE environment and your catalog, ensuring quality and seamless exposure.',
        url: 'https://avapframework.com/products/api-publisher/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/avs',
        title: 'AVAP Virtual Server: Lightweight API Lifecycle Management',
        description: 'Discover AVAP Virtual Server for exposing and managing APIs, offering scalability, version control, and multi-language support for flexible API deployment.',
        url: 'https://avapframework.com/products/avs/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/interpreter',
        title: 'AVAP Interpreter & Language Server: Fast Virtual API Development',
        description: 'AVAP Interpreter & Language Server for scalable Virtual API development, real-time interpretation, and AI-powered code enhancement. Boost your workflow.',
        url: 'https://avapframework.com/products/interpreter/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/gateway',
        title: 'AVAP Gateway Advanced: Intelligent API Traffic Routing',
        description: 'Discover AVAP Gateway Advanced, high-performance, intelligent solution for secure dynamic traffic routing, optimized performance, and scalable security.',
        url: 'https://avapframework.com/products/gateway/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/avap-zero',
        title: 'AVAP Zero: No-Code API Development Powered by Gen AI',
        description: 'Build Virtual APIs fast with Gen-AI and no code. AVAP Zero makes development simple and scalable.',
        url: 'https://avapframework.com/products/avap-zero/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/release-manager',
        title: 'AVAP API Release Manager: Seamless API Deployment',
        description: 'Discover AVAP API Release Manager, automate testing, documentation, and deployment of your APIs, directly from your code repository with full version control.',
        url: 'https://avapframework.com/products/release-manager/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/commander',
        title: 'AVAP Commander: Unified API Management for Cloud & On-Premise',
        description: 'Discover AVAP Commander, unified dashboard for managing the entire API lifecycle. Powered by Gen-AI and virtuality.',
        url: 'https://avapframework.com/products/commander/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/meshmanager',
        title: 'AVAP Mesh Manager: Simplified Hybrid Architecture Management',
        description: 'AVAP Mesh Manager, optimize resource distribution, scaling, and load balancing in hybrid environments. Enhanced flexibility, scalability, and performance.',
        url: 'https://avapframework.com/products/meshmanager/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/products/avap-vision',
        title: 'AVAP Vision: Real-Time API AI-Analytics and Visualization',
        description: 'AVAP Vision, monitor, analyze, and optimize API performance, providing actionable insights to improve API behavior and drive smarter decisions.',
        url: 'https://avapframework.com/products/avap-vision/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/resources/avap-marketplace',
        title: 'AVAP Marketplace: Discover & Monetize API Products',
        description: 'Discover AVAP Marketplace, a collaborative platform for exploring, integrating, and monetizing API products. Unlock new opportunities for your business.',
        url: 'https://avapframework.com/resources/avap-marketplace/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/cli',
        title: 'AVAP CLI: Command-Line Control for Scalable API Management',
        description: 'AVAP CLI streamlines API management via command line, enabling efficient deployment, integration, and full environment control.',
        url: 'https://avapframework.com/resources/cli/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/resources/shell',
        title: 'AVAP Shell: Batch Command Execution for Smarter API Operations',
        description: 'AVAP Shell enables batch processing for APIs, automating tasks and delivering real-time insights at scale.',
        url: 'https://avapframework.com/resources/shell/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/platon',
        title: 'PLATON, Programming Language Architecture for True Open Virtualization',
        description: 'Discover PLATON, an open-source project offering the kernel and specifications for a virtual programming language. Revolutionize your development approach.',
        url: 'https://avapframework.com/platon/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
    {
        path: '/about',
        title: 'AVAP About Us: Our Mission, Values, and Innovation',
        description: 'Discover our mission, core values, and our journey in API innovation. Learn how we\'re shaping the future of API technology with Gen-AI and virtuality at our core.',
        url: 'https://avapframework.com/about/',
        favicon: '/assets/img/Favicon_AVAP_Framework.png',
    },
];
